import React, { useEffect, useState } from "react";
import "./ProductAnalytics.scss";
import BarChart from "../Charts/BarChart/BarChart";
import { useSelector } from "react-redux";

const colors = ["#C1E6F6", "#DCF2FB", "#115774", "#65C1E8", "#092B3A"];

const ProductAnalytics = () => {
  const { currency } = useSelector((state) => state.organizationReducer.value);
  const { productsAnalytics: productsAnalyticsData } = useSelector(
    (state) => state.analyticsReducer
  );

  const [totalData, setTotalData] = useState({
    total_amount: 0.0,
    total_quantity: 0,
  });

  const [data, setData] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: colors,
        borderWidth: 0,
      },
    ],
  });

  useEffect(() => {
    const labels = [];

    const dataSet = [];

    let temp_total = 0;
    let temp_quantity = 0;

    productsAnalyticsData?.revenue_by_products?.forEach((el) => {
      temp_quantity += el?.quantity || 0;
      temp_total += el?.amount || 0;
      if (labels.length < 5) {
        labels.push(el?.name || "N/A");
        dataSet.push(el?.quantity);
      } else {
        if (labels.length === 5) {
          labels[4] = "Others";
          dataSet[4] = (dataSet[4] || 0) + el?.quantity || 0;
        } else {
          dataSet[4] += el?.quantity || 0;
        }
      }
    });

    setTotalData({
      total_amount: Number(temp_total).toFixed(2),
      total_quantity: temp_quantity,
    });

    setData({
      labels: labels,
      datasets: [
        {
          data: dataSet,
          backgroundColor: colors,
          borderWidth: 0,
        },
      ],
    });
  }, [productsAnalyticsData]);
  return (
    <div className="product-analytics">
      <div className="container-wrapper product-sales">
        <p className="heading">Products Graph</p>

        <div className="product-chart">
          <div className="chart-container">
            {data?.labels?.length < 1 && (
              <p className="no-data">No data present for this period.</p>
            )}
            <p className="chart-title">
              <span>Total Quantity:</span> {totalData.total_quantity || "0"}
            </p>
            <BarChart data={data} />
          </div>
        </div>

        <p className="heading">Revenue Record</p>

        <div className="revenue-table">
          <div className="row head">
            <p>S.N.</p>
            <p>Name</p>
            <p>Amount</p>
            <p>Quantity</p>
          </div>

          <div className="table-body">
            {productsAnalyticsData?.revenue_by_products?.map((el, i) => {
              return (
                <div className="row" key={i}>
                  <p>{i + 1}</p>
                  <p>{el?.name || "N/A"}</p>
                  <p className="price">
                    {currency}
                    {Number(el?.amount).toFixed(2) || "0.00"}
                  </p>
                  <p className="sales-font">{el?.quantity || 0}</p>
                </div>
              );
            })}

            <div className="row total">
              <p>*</p>
              <p>Total</p>
              <p>
                {currency}
                {totalData.total_amount || "0.00"}
              </p>
              <p>{totalData.total_quantity || 0}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductAnalytics;
